import * as React from 'react';
import { Check } from '@sravni/react-icons';
import { useStyles, noop } from '@sravni/react-utils';
import modules_6cfce947 from '../styles/Checkbox.module.less.js';

/**
 * @description The Checkbox component allows user to select multiple items from a list
 *
 * @component
 * @example
 * ```jsx
 * <Checkbox name="radio" value="default" label="Checkbox default" checked disabled />
 * ```
 */
const Checkbox = React.forwardRef((props, ref) => {
    const { name, value, checked, disabled, className, children, readOnly, onChange = noop, ...restProps } = props;
    const cx = useStyles(modules_6cfce947);
    const classNames = cx(className, 'container', {
        checked,
        disabled,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'read-only': readOnly,
    });
    const controlClassNames = cx('control', {
        checked,
        disabled,
    });
    return (React.createElement("label", { "data-qa": "Checkbox", className: classNames },
        React.createElement("input", { ref: ref, className: cx('input'), type: "checkbox", name: name, value: value, checked: checked, disabled: disabled, onChange: onChange, ...restProps }),
        React.createElement("div", { className: controlClassNames }, checked ? React.createElement(Check, { className: cx('icon') }) : null),
        children ? React.createElement("span", { className: cx('label') }, children) : null));
});
Checkbox.defaultProps = {
    checked: false,
};
Checkbox.displayName = 'Checkbox';

export { Checkbox };
//# sourceMappingURL=Checkbox.js.map
